import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import { Tooltip } from '../';
import Title from './Title';

export var TooltipHeader = function TooltipHeader(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      _ref$content = _ref.content,
      content = _ref$content === undefined ? [] : _ref$content;

  if (R.isEmpty(content)) return null;

  var listContent = React.createElement(
    'ul',
    { className: classes.content },
    R.addIndex(R.map)(function (_ref2, index) {
      var header = _ref2.header,
          label = _ref2.label,
          _ref2$sub = _ref2.sub,
          sub = _ref2$sub === undefined ? [] : _ref2$sub;
      return React.createElement(
        'li',
        { key: label + '-' + index },
        React.createElement(Title, { header: header }),
        label,
        R.not(R.isEmpty(sub)) && React.createElement(
          'ul',
          { className: classes.subContent },
          R.addIndex(R.map)(function (_ref3, index) {
            var label = _ref3.label;
            return React.createElement(
              'li',
              { key: label + '-' + index },
              label
            );
          }, sub)
        )
      );
    }, content)
  );

  return React.createElement(
    Tooltip,
    {
      title: listContent,
      tabIndex: 0,
      'aria-label': R.pipe(R.pluck('label'), R.join(', '))(content),
      'aria-hidden': false,
      placement: 'top',
      PopperProps: {
        modifiers: {
          flip: {
            behavior: ['top', 'bottom', 'left', 'right']
          }
        }
      }
    },
    children
  );
};

TooltipHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  classes: PropTypes.object,
  content: PropTypes.arrayOf(PropTypes.shape({
    header: PropTypes.string,
    label: PropTypes.string,
    sub: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string
    }))
  }))
} : {};

export default TooltipHeader;